<template lang="pug">
  div
    table.table.table--bars
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.date' | translate }}
          th.table__cell {{ 'base.loading' | translate }}
          th.table__cell {{ 'base.animal_type' | translate }}
          th.table__cell {{ 'base.ration' | translate }}
          th.table__cell {{ 'base.groups_cnt' | translate }}
          th.table__cell {{ 'base.animal_cnt' | translate }}
      v-table-body(
        :cols="6"
        :loading="loading"
        :empty="!items.length")
        tr.table__row(
          v-for="(item, index) in items"
          :key="item.id")
          td.table__cell {{ formateDateString(item.planned_on) }}
          td.table__cell {{ shortVersion(item.schedule_loading.name) }}
          td.table__cell {{ shortVersion(item.schedule_groups_list.animal_types[0]) }}
          td.table__cell {{ shortVersion(item.schedule_ration.name) }}
          td.table__cell {{ item.schedule_groups.length }}
          td.table__cell {{ item.schedule_groups_list.animal_count }}
    v-dialog(
      :max-width="1160"
      :value="selectedId !== null"
      @input="selectedId = null")
      //- planfeed-detail(
      //-   :selected="selectedItem"
      //-   @close="selectedId = null")
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'
// import { dateString } from '@/util'
import { getDateForDatePicker, dateString } from '@/util'
// import PlanfeedDetail from './PlanfeedDetail.vue'
import paginationMixin from '@/mixins/pagination.mixin'
export default {
  name: 'Planfeed',

  components: {
    UiPagination
    // PlanfeedDetail
  },

  async mounted () {
    const farmId = this.$route.params.farm_id
    sessionStorage.removeItem(`reports_${farmId}_planfeed`)
    this.watchFilters = false

    const hasDateFilters = this.filters.planned_on_before && this.filters.planned_on_after
    /* eslint-disable camelcase */
    const today = getDateForDatePicker(this.timezone)
    const planned_on_before = hasDateFilters ? this.filters.planned_on_before : today
    const planned_on_after = hasDateFilters ? this.filters.planned_on_after : today

    const baseFilters = {
      planned_on_before,
      planned_on_after,
      farm: farmId
    }
    /* eslint-enable camelcase */
    const fullFilters = hasDateFilters
      ? {
        ...baseFilters,
        group: [],
        animal_type: [],
        ration: [],
        loading: [],
        status: [],
        loaded_time_max: null,
        loaded_time_min: null
      }
      : baseFilters

    this.$store.dispatch('reports/applyFilters', fullFilters)

    await this.setupPagination(
      api.reports.planfeed.list,
      {
        ...baseFilters,
        page: this.page > 1 ? this.page : 1
      },
      `reports_${farmId}_planfeed`
    )
    this.$store.dispatch('reports/applyTotal', this.pageCount)

    this.watchFilters = true
  },

  data: () => ({
    selectedId: null,
    loaded: false,
    watchFilters: true
  }),
  mixins: [paginationMixin],
  computed: {
    ...mapGetters('reports', [
      // 'planfeed',
      'filters',
      'totalCount',
    ]),

    selectedItem () {
      return this.items.find(item => item.id === this.selectedId)
    },

    allowView () {
      return this.hasPermission('planfeed', 'view')
    },
    timezone () {
      return this.$store.getters['account/timezone']
    },
  },

  methods: {
    // ...mapActions('reports', [
    //   'getPlanfeed'
    // ]),



    // onSelect (item) {
    //   this.selectedId = item.id
    // },

    formateDateString (str) {
      return dateString(str)
    },

    shortVersion (str) {
      return str.length > 20 ? (str.substring(0, 20) + '...') : str
    }
  },
  watch: {
    filters: {
      async handler () {
        const farmId = this.$route.params.farm_id
        if (this.watchFilters) {
          await this.$router.push({
            query: {
              ...this.$route.query,
              page: 1
            }
          })
          if (!this.filters.planned_on_before && !this.filters.planned_on_after) {
            const today = getDateForDatePicker(this.timezone)
            this.$store.dispatch('reports/applyFilters', {
              planned_on_before: today,
              planned_on_after: today,
              farm: farmId
            })
          }
          await this.setupPagination(
            api.reports.planfeed.list,
            {
              farm: farmId,
              ...this.filters,
              page: 1
            },
            `reports_${farmId}_planfeed`
          )
        }
        this.$store.dispatch('reports/applyTotal', this.pageCount)
      },
      deep: true
    }
  }
}
</script>
